import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tutoriales',
  templateUrl: './tutoriales.component.html',
  styles: ['./tutoriales.component.css']
})
export class TutorialesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
